import { Component } from '@mycolorway/tao';
import { Option } from 'next/javascripts/components/select-list';
import Dialog from 'next/javascripts/components/dialog';
import 'next/stylesheets/components/member-batch-select/dialog.scss';
import 'next/stylesheets/components/form-fields/member-scope-select-field/dialog.scss';

Component('tr-member-scope-select-dialog', {
  extends: [Dialog],

  properties: {
    fieldId: String,
  },

  connected() {
    this.listenTo(this, 'tao:closed', (event) => {
      if (event.detail === 'yes') this.confirmSelect();
    });
  },

  confirmSelect() {
    const field = document.getElementById(this.fieldId);
    if (field) field.setSelectedOptions(this.getSelectedOptions());
  },

  getSelectedOptions() {
    const batchSelectField = this.querySelector('tr-member-batch-select-field');
    const selectedItems = batchSelectField
      .resultsList.querySelectorAll('.result-item.selected');

    return Array.from(selectedItems).map((item) => {
      const {
        type, id, nickname, name, ...data
      } = item.dataset;
      const text = type === 'member' ? nickname : name;

      return new Option(text, id, data);
    });
  },
});
